const videoStatusTypes = {
	NONE: 0,
	PROCESSING: 1,
	SUCCESS: 2,
	FAILED: 3,
	UPLOADING: 4,
}

const findVideoStatus = versions => {
	let status = videoStatusTypes.PROCESSING
	const statusArray = []
	versions.forEach(version => {
		Object.values(version.videos).forEach(video => {
			statusArray.push(video.status)
		})
	})
	if (statusArray.includes(videoStatusTypes.SUCCESS)) {
		status = videoStatusTypes.SUCCESS
	} else if (!statusArray.includes(videoStatusTypes.PROCESSING)) {
		status = videoStatusTypes.FAILED
	}
	return status
}

export {
	findVideoStatus,
	videoStatusTypes,
}
